import { selectIsFreemium } from 'modules/accountStatus/store/selectors';
import { useAccountStatusQuery } from 'modules/accountStatus/actions/hooks/useAccountStatusQuery';
import { useAppSelector } from 'store/useAppSelector';
import { useAuth } from 'modules/auth/hooks/useAuth';

import {
  UseInitPersonalAccountProps,
  useInitPersonalAccount,
} from './useInitPersonalAccount';
import { usePersonalAccountState } from './usePersonalAccountState';

export interface UsePersonalAccountStatusProps
  extends UseInitPersonalAccountProps {}

export const usePersonalAccountStatus = ({
  skipFetching,
}: UsePersonalAccountStatusProps = {}) => {
  const { isInitialized, isInitializing, userEndpointToken } =
    usePersonalAccountState();

  useInitPersonalAccount({ skipFetching });

  const { isLoggedIn } = useAuth();

  const {
    loading: accountStatusLoading,
    params,
    state: { isSuccess: accountStatusLoaded },
    status: personalAccountStatus,
  } = useAccountStatusQuery({
    skipFetching: !userEndpointToken || !isLoggedIn,
    userEndpointToken: userEndpointToken!,
  });

  const isPersonalAccountFreemium = useAppSelector(state =>
    selectIsFreemium(state, params),
  );

  const isPersonalAccountStatusLoaded = isInitialized && accountStatusLoaded;
  const isPersonalAccountStatusLoading = isInitializing || accountStatusLoading;

  return {
    isPersonalAccountFreemium,
    isPersonalAccountStatusLoaded,
    isPersonalAccountStatusLoading,
    personalAccountStatus,
    userEndpointToken,
  };
};
